import styled, { css } from 'styled-components';
import { Buttons, FormTitle } from '../Shared/FormContainer/styled';
import { ContainerDefault, WrapperDefault } from '../Shared/Shared';

export const FormCheckboxWrapper = styled(WrapperDefault)`
  @media (max-width: 1200px) {
    padding: 0;
    ${FormTitle},
    ${Buttons} {
      padding-left: 24px;
    }
  }
`;

export const FormCheckboxContianer = styled(ContainerDefault)`
  overflow-y: hidden;
  flex-wrap: wrap;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 24px;
  min-height: 100px;
  max-height: 220px;
  padding: 10px 0;
  @media (max-width: 1200px) {
    padding: 0 20px 20px 24px;
    width: 100%;
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Checkbox = styled.span`
  position: absolute;
  left: 0;
  width: 40.7px;
  height: 39px;
  border-radius: 12px;
  border: solid 2px var(--black);
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    fill: transparent;
    stroke: transparent;
  }
`;

export const Accessibility = styled.span`
  opacity: 0.6;
  font-size: 12px;
  user-select: none;
  span {
    font-weight: bold;
  }
  @media (max-width: 1200px) {
    display: none;
  }
`;

export const FormCheckboxLabel = styled.label<{ disabled?: boolean }>`
  position: relative;
  cursor: pointer;
  font-size: 22px;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding-left: 59px;
  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    opacity: 0.85;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:hover ~ img {
      opacity: 1;
    }

    &:checked ~ ${Checkbox} {
      svg {
        fill: var(--dark-gray);
        stroke: var(--dark-gray);
      }
    }
  }

  ${props =>
    props?.disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;

export const Name = styled.span`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
`;

export const NewPetButton = styled.button`
  align-self: flex-start;
  justify-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  height: 50px;
  border: none;
  cursor: pointer;
  user-select: none;

  div {
    width: 26px;
    height: 26px;
    border: dashed 1.5px var(--dark-gray);
    border-radius: 8px;
  }
  span {
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
  }

  &:hover {
    div {
      background: var(--dark-gray);
      .plus-svg {
        stroke: var(--white);
        fill: var(--white);
      }
    }
  }
`;
